import React from "react";
import "./style.scss";

const HeaderBaseLayout = (props) => {
  return (
    <div
      className={`base-header`}
      style={
        props.isCustomPicture
          ? { backgroundImage: props.picture }
          : {
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "/SKOR-Survey-BG.png"
              })`,
            }
      }
    >
      <div className="header-button">
        <a href="">
          <img src={props.src} alt="logo_image" onClick={props.onClick} />
        </a>
      </div>
      <div className="header-text">
        <span className="text-title">{props.title}</span>
      </div>
    </div>
  );
};

export default HeaderBaseLayout;
